/* @flow */
import { Container } from 'flux/utils';
import React from 'react';
import QuickPromotion from 'entities/QuickPromotion';
import CurrentUser from 'auth/CurrentUser';
import QuickPromotionModal from 'components/QuickPromotionModal.jsx';
import { handleResponse } from 'lib/QuickPromotionActionHandler';
import { TriggerTypes, ResponseTypes } from 'constants/QuickPromotionConstants';
import { mountModal } from 'lib/modal';

type State = {
  promotions: Array<QuickPromotion>,
};

class QuickPromotionAppOpenedModals extends React.Component {
  state: State;

  static contextTypes = {
    router: React.PropTypes.object.isRequired,
  };

  static getStores() {
    return [CurrentUser];
  }

  static calculateState(): State {
    return {
      promotions: CurrentUser.getQuickPromotionsForTrigger(TriggerTypes.APP_OPENED),
    };
  }

  componentDidMount() {
    this.checkForPrompts();
  }

  componentDidUpdate() {
    this.checkForPrompts();
  }

  shown = false;

  onConfirm = (promotion: QuickPromotion) => {
    handleResponse(this.context.router, promotion, ResponseTypes.PRIMARY_ACTION);
  }

  onCancel = (promotion: QuickPromotion) => {
    handleResponse(this.context.router, promotion, ResponseTypes.SECONDARY_ACTION);
  }

  checkForPrompts() {
    const { promotions } = this.state;

    if (!this.shown) {
      const promotion = promotions.find((p) => p.isShowable());
      if (promotion) {
        this.shown = true;
        mountModal(
          <QuickPromotionModal
            onConfirm={this.onConfirm}
            onCancel={this.onCancel}
            promotion={promotion}
            triggeredContext={'quick_promotion:' + promotion.getPromotion()}
            onRequestHide={() => {}/* Flow can't deal with injected props */}
          />, this);
      }
    }
  }

  render() {
    return null;
  }
}

export default Container.create(QuickPromotionAppOpenedModals, { pure: false });



// WEBPACK FOOTER //
// ./src/components/QuickPromotionAppOpenedModals.jsx